import { apiFetch } from "@/client/lib/api";

/**
 * Typed client for the customer API-token endpoints. Tokens authenticate
 * non-interactive callers (e.g. node Redfish from a terminal). All requests are
 * scoped server-side to the authenticated tenant, so the client never passes a
 * tenant id. The raw token is returned only once, on create.
 */

export interface ApiToken {
  id: string;
  name: string;
  /** Non-secret leading slice of the token, shown to tell tokens apart. */
  tokenPrefix: string;
  createdAt: string;
  lastUsedAt: string | null;
  /** ISO timestamp, or null when the token never expires. */
  expiresAt: string | null;
}

/** The create response: the token view plus the raw secret (shown once). */
export interface CreatedApiToken extends ApiToken {
  token: string;
}

export interface CreateApiTokenInput {
  name: string;
  /** One of 30 / 90 / 365 days, or null to never expire. */
  expiresInDays: 30 | 90 | 365 | null;
}

export const apiTokensApi = {
  list: () => apiFetch<{ tokens: ApiToken[] }>("/api-tokens"),
  create: (input: CreateApiTokenInput) =>
    apiFetch<CreatedApiToken>("/api-tokens", { method: "POST", json: input }),
  revoke: (id: string) => apiFetch<void>(`/api-tokens/${id}`, { method: "DELETE" }),
};
